<script>
import { computed, defineComponent, ref, watch } from 'vue'
import { useAuth } from 'src/composables/useAuth'
import { useCart } from 'src/composables/useCart'
import { useLayout } from 'src/composables/useLayout'
import { useQuasar } from 'quasar'
import { useRoute, useRouter } from 'vue-router'
import HoverablePopup from 'components/general/HoverablePopup'
import CountrySelector from 'components/general/CountrySelector'
import SearchResultViewer from 'components/layout/SearchResultViewer'
import SmallCart from 'components/cart/SmallCart'

export default defineComponent({
  name: 'AppHeader',
  components: { SmallCart, SearchResultViewer, CountrySelector, HoverablePopup },
  setup () {
    try {
      let { showLogin, userDetailsLoaded, authTab } = useAuth()
      const { shoppingCartCount } = useCart()
      const { showDrawer, translate, productFamilies, language, categories, extraMenus, showSearchResults, showMobileSearchResults } = useLayout()
      const $q = useQuasar()
      const route = useRoute()
      const router = useRouter()
      const showSmallCart = ref(false)
      const showMobileSmallCart = ref(false)

      const openProductFamily = async (productFamily) => {
        showDrawer.value = false
        await router.push(`/termekek/${productFamily.url}`)
        closePopups()
      }
      const openCategory = async (category) => {
        showDrawer.value = false
        await router.push(`/termekek/${category.url}`)
        closePopups()
      }

      const closePopups = (fieldToToggle) => {
        switch (fieldToToggle) {
          case '/' : {
            window.scrollTo({ top: 0, behavior: 'smooth' })
            showLogin.value = false
            showSmallCart.value = false
            showSearchResults.value = false
            showDrawer.value = false
            showMobileSearchResults.value = false
            showMobileSmallCart.value = false
            break
          }
          case 'showLogin' : {
            showLogin.value = !showLogin.value
            showSmallCart.value = false
            showSearchResults.value = false
            showDrawer.value = false
            showMobileSearchResults.value = false
            showMobileSmallCart.value = false
            break
          }
          case 'showSmallCart' : {
            showLogin.value = false
            showSmallCart.value = !showSmallCart.value
            showSearchResults.value = false
            showDrawer.value = false
            showMobileSearchResults.value = false
            showMobileSmallCart.value = false
            break
          }
          case 'showSearchResults' : {
            showLogin.value = false
            showSmallCart.value = false
            showSearchResults.value = !showSearchResults.value
            showDrawer.value = false
            showMobileSearchResults.value = false
            showMobileSmallCart.value = false
            break
          }
          case 'showMobileSearchResults' : {
            showLogin.value = false
            showSmallCart.value = false
            showSearchResults.value = false
            showDrawer.value = false
            showMobileSearchResults.value = !showMobileSearchResults.value
            showMobileSmallCart.value = false
            break
          }
          case 'showDrawer' : {
            showLogin.value = false
            showSmallCart.value = false
            showSearchResults.value = false
            showDrawer.value = !showDrawer.value
            showMobileSearchResults.value = false
            showMobileSmallCart.value = false
            break
          }
          case 'showMobileSmallCart' : {
            showLogin.value = false
            showSmallCart.value = false
            showSearchResults.value = false
            showDrawer.value = false
            showMobileSearchResults.value = false
            showMobileSmallCart.value = !showMobileSmallCart.value
            break
          }
          default: {
            showLogin.value = false
            showSmallCart.value = false
            showSearchResults.value = false
            showDrawer.value = false
            showMobileSearchResults.value = false
            showMobileSmallCart.value = false
          }
        }
      }

      const openUrl = async (url) => {
        try {
          console.log('URL', url)
          if (url === '/') {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
          console.log('OPENING URL', url)
          await router.push(url).catch(() => {})
          closePopups()
        } catch (e) {
          console.log('DÖGÖLJ MEG', e)
        }
      }

      const goSticky = ref(false)

      const currentPage = computed(() => {
        return route.path
      })

      const firstCategories = computed(() => {
        return categories.value.slice(0, Math.round(categories.value.length / 2))
      })

      const secondCategories = computed(() => {
        return categories.value.slice(Math.floor(categories.value.length / 2) + 1, categories.value.length)
      })

      watch(currentPage, () => {
        showSearchResults.value = false
        showMobileSearchResults.value = false
        showLogin.value = false
      })

      const openFb = () => {
        window.open('https://www.facebook.com/puregoldprotein', '_blank').focus()
      }
      const openInsta = () => {
        window.open('https://www.instagram.com/puregoldprotein/', '_blank').focus()
      }
      const onScroll = (info) => {
        goSticky.value = info.position.top > 32
      }
      const openProfile = () => {
        if (!userDetailsLoaded.value) {
          showLogin = false
          $q.notify({ type: 'info', message: translate('product.needToLogin') })
          return
        }
        if (currentPage.value !== '/profil') {
          router.push('/profil')
        }
        closePopups()
      }

      const openYoutube = () => {
        window.open('https://www.youtube.com/channel/UC5ELQlLQ0ulZikn_jIpLQqg', '_blank').focus()
      }

      return {
        translate,
        productFamilies,
        showSearchResults,
        showMobileSearchResults,
        groupOfferItems: ref(null),
        authHover: ref(false),
        goSticky,
        loginPopupShown: ref(false),
        productPopupShown: ref(false),
        productFamilyPopupShown: ref(false),
        showSmallCart,
        showMobileSmallCart,
        thumbStyle: {
          right: '0px',
          borderRadius: '8px',
          backgroundColor: '#2D5ED9',
          width: '8px',
          opacity: 0.55
        },
        showLogin,
        openUrl,
        closePopups,
        authTab,
        categories,
        extraMenus,
        openFb,
        openInsta,
        openProductFamily,
        onScroll,
        openCategory,
        openProfile,
        openYoutube,
        shoppingCartCount,
        userDetailsLoaded,
        language,
        showDrawer,
        secondCategories,
        firstCategories
      }
    } catch (e) {
      console.log('APP HEADER E', e)
    }
  }
})
</script>

<template lang="pug">
div(:style="`background: #F2F2F2;`")
  .full-width.flex.justify-center
    .gt-sm.contentWidth.row.justify-between(style="height: 32px;color:rgba(255,255,255,0.4)")
      .row.flex.items-center.q-pl-lg
        a.cursor-pointer.flex-center.flex(@click="openFb" target="_blank" href="https://www.facebook.com/puregoldprotein")
          svg(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' fill="#B0B1B3")
            path(fill='none' d='M0 0h24v24H0z')
            path(d='M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z')
        a.cursor-pointer.flex-center.flex(@click="openInsta" target="_blank" href="https://www.instagram.com/puregoldprotein/")
          svg(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' fill="#B0B1B3")
            path(fill='none' d='M0 0h24v24H0z')
            path(d='M12 2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153a4.908 4.908 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 0 1-1.153 1.772 4.915 4.915 0 0 1-1.772 1.153c-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 0 1-1.772-1.153 4.904 4.904 0 0 1-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 0 1 1.153-1.772A4.897 4.897 0 0 1 5.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2zm0 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm6.5-.25a1.25 1.25 0 0 0-2.5 0 1.25 1.25 0 0 0 2.5 0zM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z')
        a.cursor-pointer.flex-center.flex(@click="openYoutube" target="_blank" href="https://www.youtube.com/channel/UC5ELQlLQ0ulZikn_jIpLQqg")
          svg(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' fill="#B0B1B3")
            path(fill='none' d='M0 0h24v24H0z')
            path(d='M21.543 6.498C22 8.28 22 12 22 12s0 3.72-.457 5.502c-.254.985-.997 1.76-1.938 2.022C17.896 20 12 20 12 20s-5.893 0-7.605-.476c-.945-.266-1.687-1.04-1.938-2.022C2 15.72 2 12 2 12s0-3.72.457-5.502c.254-.985.997-1.76 1.938-2.022C6.107 4 12 4 12 4s5.896 0 7.605.476c.945.266 1.687 1.04 1.938 2.022zM10 15.5l6-3.5-6-3.5v7z')

      .row.flex.justify-end
        router-link(to="/vevoszolgalat" @click="$route.path === '/vevoszolgalat' ? closePopups() : openUrl('/vevoszolgalat')")
          q-item.topHeaderText(dense clickable).flex.flex-center {{ translate('home.customerService') }}
        country-selector(:dense="true" :header="true")

  q-scroll-observer(@scroll='onScroll')
  .isMobile(style="height:55px;")
  .isMobile.fixedElement.row.full-width.bg-white(style="height:55px;" :class="goSticky || showLogin || showSmallCart || showMobileSmallCart || showSearchResults || showSearchResults ? 'headerShadow' : ''").flex.items-center.justify-evenly
    .flex.justify-center
      .cursor-pointer(@click="closePopups('showDrawer')").flex.flex-center
        svg(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' fill="#0370F7")
          path(fill='none' d='M0 0h24v24H0z')
          path(d='M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z')

    .flex.justify-center
      .cursor-pointer.flex.flex-center(@click="closePopups('showMobileSearchResults')")
        svg(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' :fill="showMobileSearchResults ? '#f1222a' : '#0370F7'")
          path(fill='none' d='M0 0h24v24H0z')
          path(d='M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z')
        search-result-viewer(v-model:visible="showMobileSearchResults")
    .flex.justify-center.cursor-pointer(@click="$route.path === '/' ? closePopups('/') : openUrl('/')")
      svg#Layer_1(xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' x='0px' y='0px' width='100px' height='46px' viewBox='0 0 128 46' enable-background='new 0 0 128 46' xml:space='preserve')
        image#image0(width='128' height='46' x='0' y='0' href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAuCAMAAADX9uFnAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAC4lBMVEVNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1P////5tCdRAAAA9HRSTlMAzPLt 7+zduVphstx+cY+EdKadn4ZGOqSJF6MdOJ55MzalNyaHw82zY2UFjqcycKmgoaKIS9cMavwpNWia /dDSIAlbxhu7xVzbIy5YP9gDPQjiT7GqTZPoWVJuGlddy3NgylBmr2mVm9YE6WQZtaxUtHW6fbiL MBiM03dvLSwlgMDImCsngr9FfNlthdo75EA+QyExPHj3xxO9wcLVAZnUHOXu9Q8H62sU8fooDnKo kXpW5h8vDUH+FklCXxD5lKv7zrzRl75/307j9viKYgp7Hl4SAs85t2yDgclIEUqSnCLnduHeBguW 4K7wtirE8yQVUY1M+pPn3AAAAAFiS0dE9UXSG9sAAAAHdElNRQflCxoGCSQrZYVRAAAGeElEQVRY w+2Y+1/MWRjHT1qZCstUO2xuraaYWCHJYpoUUSmXFNpmZzdLYUWaJexujXSxTYiMUtE2Vi5r065Y u+kmYckltIui9oa19+cP2Od8L9Ok75TU69Uvntdrzuf7zLm9v+ec7/N9ZohZL/NXeszMe5mR3tCj 1ptYQB+RZQ+ZyAqsEaAv6THrxwD07zmAV18CvAQwAhgwUCy2sbG1Y2teGygZhDJY/LqNPeoQyVCs FQ8bztaOcEAXbajDG4w/0lHq5DzKMOxIW3RHs9cylzFjxhpq3hzn6jp+wkQ3IYBJXGTo4069yQAe KFPwi7dQp/JxYxrTdrQhjkyl7qjpzLXcnh3V0oNxPRXU8cKrGQYAM66bt09bgJn8mLOo5wswG2UO Du2HKjLMOJHW+htcetsBvDM3kFYG8a61DL158wEWGAAW8nWTZEIAwYv8Q4Bt3xYgdPGSpZ5YG8YC hPq+LRKJwuldKgF6vbNEgnUqOtC76A54j7oRQgDL3EQSjrwNwPsoywFWCAJEokStBFjFAkwyDLoa h1uC+gHAGnps0I1GXQtgJQSwDiUGOYQA1qPYAcQKAljTRmsA1CyARRQ/6Ic44wbUjQBxKH7cKm0C kAoBOKJsxlPQDoDUNIAYQPwswBaccQ5qdHDwJpSP0P0Y9ROAeFMAeMQTXgxgPIDmWQB+Rs62opuI ug0g6UVWIBlgpiAAdYk3QAoLkEqMAUZ2D8B2lE8BxgsCpKGE4+BaFiB9h3bnzl0ZHEBi9wBodu/J xCDiLwiwVxdPY5V3qzjgwgHsk2Vlx8fvd+wiAGs5ucRkIJqu3NcKII8DmOfFuMruADhwkAgCeOR/ BpDPjoMABTGxMTH7LTkA/aHen+8FcO4igEVs0prDTDgVALA4VHgEjh7jAVofwjmk8Li66wBftBwl wUN4AuBLHsC6FQCdMbPrAEXtAeCMJwGKeYC2cWDb8wMsBdCZigOchbPR/isE+NoAcAq3uaQNAI29 CtT1AGtJS2DsC5BNXiAScqYCmI9SeBpgrAGAWLFvqtZbQGc8wwLEcgtCXw0pAPs5gG+MAWxRigCy OgA4i8O4MW8UGNwC8C2AuYwFmG1o+l0pkyXocwBc0T1+FACTKX0cgAMHkGwMkIl1GFDOdQAgKwY4 LSkDdll5gH3lAItYgL0JUp0uoYJmcOOwVaVrPpY7aNsT1LVJx9KOA0iTKpVKeQgLUHXeIZ/Ls1oD VANcaAEgO7mwUE63l8wAqOEoy1AWGzIimnOsNuecoUzPDfyvTQn15hXzTavQc+YdLhE2BqgC2GgE QC5eog2d/BgHk8DLNEDS3PAgJoEGAJqeEEU8vfzekeupqKZu6RXG8fLgm1YQ5mVGrYZ/4I0Bdlle 9TMGILWL1bYXuesMlWoBBXAPD4/A1FOhmsGaSsEdmWtXIuxbupZcU0dcZy8DF/j6M3aDPj8BN/z9 RSe1MiIA0CP2EqD7AKICOeUD5E381EXV4SHADxZ1gbkmAVy6OvvNWZFO8oThpLYyUimvooF3VGTa LS25mlphVhGXRFblKOWeqbfJnRGk/g7tcO081/MHBuBHkyPXPR/AMZiqLdGU+8hgnTYoBQPfUojY rQbtQbuSyzYBAaTy7p5ku3v3vcobMLTSYDNOzvUcgADWUNWoEbI8q3P3sU1G4wNNeya+QB6m67Hh gUGk6Tpq7DJypBk1i75xK3yxqGY32f2ns6To56O3CTkfQx6uyNNoGp0QoNTkH1gFbrkkcHvHf3QR n/RfcPzQZlKsQC1oJk1BdJ1vYRF3GIsYDQPwKwL8FjIaCMmLIfe4zqXEwTvpWat2xjcJPKAbkJwm T2rfdDbkjHljc0rCo9rcUOXjhbqsOtmjAOxapOMB8p5U6uTDSC0ChPxO8oPpCjyVZtPe3g7Cu/oH wGR22Z7nDPgcmWV1Z5o7KWxaXv/nE7zV+QzAXR7gRHZ0uGoIswKNUmIPT+urOxixGdKHdOIpeJrO cq5uCsPfpn6k7slZ9CZG8gCV/Q1b0BiPo19aUdb+gInQ534n5ieJoX8xOnjlCELKMJFxwpvPPU3f vzn19BCymaT7JdwCmqQ4d/Dk61MndGZ6mgRtZTQM8PCdgs0ko+bug5p4GpPMM+mEBZLHyxZuCZze QCRzKQmTLZq26H6dm5/oRXpGvUR/Y9kgwqKv61Xmq3+mYLF73b9qtcsx4h9GbjfQb4P+a+n8P6Px 3nM88gkFAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTExLTI2VDA2OjA5OjI3KzAwOjAw9e6N6wAA ACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0xMS0yNlQwNjowOToyNyswMDowMISzNVcAAAAZdEVYdFNv ZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAAAAElFTkSuQmCC')
    .flex.flex-center
      .cursor-pointer.flex.flex-center(@click="openProfile" v-if="userDetailsLoaded")
        svg(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' :fill="showLogin ? '#F1222A' : '#0370F7'")
          path(fill='none' d='M0 0h24v24H0z')
          path(d='M12 17c3.662 0 6.865 1.575 8.607 3.925l-1.842.871C17.347 20.116 14.847 19 12 19c-2.847 0-5.347 1.116-6.765 2.796l-1.841-.872C5.136 18.574 8.338 17 12 17zm0-15a5 5 0 0 1 5 5v3a5 5 0 0 1-4.783 4.995L12 15a5 5 0 0 1-5-5V7a5 5 0 0 1 4.783-4.995L12 2zm0 2a3 3 0 0 0-2.995 2.824L9 7v3a3 3 0 0 0 5.995.176L15 10V7a3 3 0 0 0-3-3z')
      .cursor-pointer.flex.flex-center(@click="closePopups('showLogin')" v-else)
        svg(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' :fill="showLogin ? '#F1222A' : '#0370F7'")
          path(fill='none' d='M0 0h24v24H0z')
          path(d='M12 17c3.662 0 6.865 1.575 8.607 3.925l-1.842.871C17.347 20.116 14.847 19 12 19c-2.847 0-5.347 1.116-6.765 2.796l-1.841-.872C5.136 18.574 8.338 17 12 17zm0-15a5 5 0 0 1 5 5v3a5 5 0 0 1-4.783 4.995L12 15a5 5 0 0 1-5-5V7a5 5 0 0 1 4.783-4.995L12 2zm0 2a3 3 0 0 0-2.995 2.824L9 7v3a3 3 0 0 0 5.995.176L15 10V7a3 3 0 0 0-3-3z')
    hoverable-popup.lt-md(:offset="[80, 14]" :visible="showMobileSmallCart" @update:visible="closePopups('showMobileSmallCart')")
      template(v-slot:button)
        .cursor-pointer.relative-position.flex.flex-center
          q-badge(v-if="shoppingCartCount > 0" style="background:#eeaf62;color:#000;font-weight:700; position: absolute; top: -10px; right: -10px; border-radius: 100px;") {{shoppingCartCount}}
          svg(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' :fill="showMobileSmallCart || $route.path === '/kosar' ? '#f1222a' : '#0370F7'")
            path(fill='none' d='M0 0h24v24H0z')
            path(d='M4 6.414L.757 3.172l1.415-1.415L5.414 5h15.242a1 1 0 0 1 .958 1.287l-2.4 8a1 1 0 0 1-.958.713H6v2h11v2H5a1 1 0 0 1-1-1V6.414zM6 7v6h11.512l1.8-6H6zm-.5 16a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm12 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z')
      template(v-slot:popup)
        small-cart(@clicked="showMobileSmallCart = false")

  .gt-sm(style="height: 111px;" v-if="goSticky")
  .gt-sm.full-width(:class="goSticky ? 'fixedElement' : ''")
    .flex.flex-center.full-width(style="background: white; height: 71px;")
      .contentWidth.row.justify-between
        router-link.cursor-pointer(style="padding-left: 15px;" @click="$route.path === '/' ? closePopups('/') : openUrl('/')" to="/")
          svg#Layer_1(xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' x='0px' y='0px' width='120px' height='43px' viewBox='0 0 128 46' enable-background='new 0 0 128 46' xml:space='preserve')
            image#image0(width='128' height='46' x='0' y='0' href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAuCAMAAADX9uFnAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAC4lBMVEVNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NN T1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1NNT1P////5tCdRAAAA9HRSTlMAzPLt 7+zduVphstx+cY+EdKadn4ZGOqSJF6MdOJ55MzalNyaHw82zY2UFjqcycKmgoaKIS9cMavwpNWia /dDSIAlbxhu7xVzbIy5YP9gDPQjiT7GqTZPoWVJuGlddy3NgylBmr2mVm9YE6WQZtaxUtHW6fbiL MBiM03dvLSwlgMDImCsngr9FfNlthdo75EA+QyExPHj3xxO9wcLVAZnUHOXu9Q8H62sU8fooDnKo kXpW5h8vDUH+FklCXxD5lKv7zrzRl75/307j9viKYgp7Hl4SAs85t2yDgclIEUqSnCLnduHeBguW 4K7wtirE8yQVUY1M+pPn3AAAAAFiS0dE9UXSG9sAAAAHdElNRQflCxoGCSQrZYVRAAAGeElEQVRY w+2Y+1/MWRjHT1qZCstUO2xuraaYWCHJYpoUUSmXFNpmZzdLYUWaJexujXSxTYiMUtE2Vi5r065Y u+kmYckltIui9oa19+cP2Od8L9Ok75TU69Uvntdrzuf7zLm9v+ec7/N9ZohZL/NXeszMe5mR3tCj 1ptYQB+RZQ+ZyAqsEaAv6THrxwD07zmAV18CvAQwAhgwUCy2sbG1Y2teGygZhDJY/LqNPeoQyVCs FQ8bztaOcEAXbajDG4w/0lHq5DzKMOxIW3RHs9cylzFjxhpq3hzn6jp+wkQ3IYBJXGTo4069yQAe KFPwi7dQp/JxYxrTdrQhjkyl7qjpzLXcnh3V0oNxPRXU8cKrGQYAM66bt09bgJn8mLOo5wswG2UO Du2HKjLMOJHW+htcetsBvDM3kFYG8a61DL158wEWGAAW8nWTZEIAwYv8Q4Bt3xYgdPGSpZ5YG8YC hPq+LRKJwuldKgF6vbNEgnUqOtC76A54j7oRQgDL3EQSjrwNwPsoywFWCAJEokStBFjFAkwyDLoa h1uC+gHAGnps0I1GXQtgJQSwDiUGOYQA1qPYAcQKAljTRmsA1CyARRQ/6Ic44wbUjQBxKH7cKm0C kAoBOKJsxlPQDoDUNIAYQPwswBaccQ5qdHDwJpSP0P0Y9ROAeFMAeMQTXgxgPIDmWQB+Rs62opuI ug0g6UVWIBlgpiAAdYk3QAoLkEqMAUZ2D8B2lE8BxgsCpKGE4+BaFiB9h3bnzl0ZHEBi9wBodu/J xCDiLwiwVxdPY5V3qzjgwgHsk2Vlx8fvd+wiAGs5ucRkIJqu3NcKII8DmOfFuMruADhwkAgCeOR/ BpDPjoMABTGxMTH7LTkA/aHen+8FcO4igEVs0prDTDgVALA4VHgEjh7jAVofwjmk8Li66wBftBwl wUN4AuBLHsC6FQCdMbPrAEXtAeCMJwGKeYC2cWDb8wMsBdCZigOchbPR/isE+NoAcAq3uaQNAI29 CtT1AGtJS2DsC5BNXiAScqYCmI9SeBpgrAGAWLFvqtZbQGc8wwLEcgtCXw0pAPs5gG+MAWxRigCy OgA4i8O4MW8UGNwC8C2AuYwFmG1o+l0pkyXocwBc0T1+FACTKX0cgAMHkGwMkIl1GFDOdQAgKwY4 LSkDdll5gH3lAItYgL0JUp0uoYJmcOOwVaVrPpY7aNsT1LVJx9KOA0iTKpVKeQgLUHXeIZ/Ls1oD VANcaAEgO7mwUE63l8wAqOEoy1AWGzIimnOsNuecoUzPDfyvTQn15hXzTavQc+YdLhE2BqgC2GgE QC5eog2d/BgHk8DLNEDS3PAgJoEGAJqeEEU8vfzekeupqKZu6RXG8fLgm1YQ5mVGrYZ/4I0Bdlle 9TMGILWL1bYXuesMlWoBBXAPD4/A1FOhmsGaSsEdmWtXIuxbupZcU0dcZy8DF/j6M3aDPj8BN/z9 RSe1MiIA0CP2EqD7AKICOeUD5E381EXV4SHADxZ1gbkmAVy6OvvNWZFO8oThpLYyUimvooF3VGTa LS25mlphVhGXRFblKOWeqbfJnRGk/g7tcO081/MHBuBHkyPXPR/AMZiqLdGU+8hgnTYoBQPfUojY rQbtQbuSyzYBAaTy7p5ku3v3vcobMLTSYDNOzvUcgADWUNWoEbI8q3P3sU1G4wNNeya+QB6m67Hh gUGk6Tpq7DJypBk1i75xK3yxqGY32f2ns6To56O3CTkfQx6uyNNoGp0QoNTkH1gFbrkkcHvHf3QR n/RfcPzQZlKsQC1oJk1BdJ1vYRF3GIsYDQPwKwL8FjIaCMmLIfe4zqXEwTvpWat2xjcJPKAbkJwm T2rfdDbkjHljc0rCo9rcUOXjhbqsOtmjAOxapOMB8p5U6uTDSC0ChPxO8oPpCjyVZtPe3g7Cu/oH wGR22Z7nDPgcmWV1Z5o7KWxaXv/nE7zV+QzAXR7gRHZ0uGoIswKNUmIPT+urOxixGdKHdOIpeJrO cq5uCsPfpn6k7slZ9CZG8gCV/Q1b0BiPo19aUdb+gInQ534n5ieJoX8xOnjlCELKMJFxwpvPPU3f vzn19BCymaT7JdwCmqQ4d/Dk61MndGZ6mgRtZTQM8PCdgs0ko+bug5p4GpPMM+mEBZLHyxZuCZze QCRzKQmTLZq26H6dm5/oRXpGvUR/Y9kgwqKv61Xmq3+mYLF73b9qtcsx4h9GbjfQb4P+a+n8P6Px 3nM88gkFAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTExLTI2VDA2OjA5OjI3KzAwOjAw9e6N6wAA ACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0xMS0yNlQwNjowOToyNyswMDowMISzNVcAAAAZdEVYdFNv ZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAAAAElFTkSuQmCC')
        .flex.flex-center(style="min-width: 200px; width: 40%").gt-xs
          search-result-viewer(style="width: 100%" v-model:visible="showSearchResults")
        .flex.justify-end
          .row.items-center
            hoverable-popup(:offset="[100, 0]" v-if="!userDetailsLoaded" v-model:visible="loginPopupShown")
              template(v-slot:button)
                q-item.redHover.row.items-center.q-mr-sm.q-px-sm(style="color: black; font-size: 1em; height: 36px;" no-caps dense clickable)
                  .q-mr-sm.flex.flex-center
                    svg.auth-icon(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' :fill="loginPopupShown ? '#e02838' : '#4e4f53'")
                      path(fill='none' d='M0 0h24v24H0z')
                      path(d='M12 17c3.662 0 6.865 1.575 8.607 3.925l-1.842.871C17.347 20.116 14.847 19 12 19c-2.847 0-5.347 1.116-6.765 2.796l-1.841-.872C5.136 18.574 8.338 17 12 17zm0-15a5 5 0 0 1 5 5v3a5 5 0 0 1-4.783 4.995L12 15a5 5 0 0 1-5-5V7a5 5 0 0 1 4.783-4.995L12 2zm0 2a3 3 0 0 0-2.995 2.824L9 7v3a3 3 0 0 0 5.995.176L15 10V7a3 3 0 0 0-3-3z')
                  .menuName(:class="loginPopupShown ? 'redText' : ''") {{ translate('auth.login') }}
              template(v-slot:popup)
                .loginBox.row
                  .col-12.title {{translate('auth.enterSite')}}
                  .col-12.btn(@click="authTab = 'login'; showLogin = true; showSearchResults = false") {{translate('auth.login2')}}
                  .col-12.btn2(@click="authTab = 'register'; showLogin = true; showSearchResults = false") {{translate('auth.register')}}

            q-item.row.items-center.q-mr-sm.q-px-sm(style="color: black; font-size: 1em; height: 36px;" @click="openUrl('/profil')"  no-caps dense clickable v-else)
              .q-mr-sm.flex.flex-center
                svg.auth-logo(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' :fill="authHover ? '#F0232B' : '#4e4f53'")
                  path(fill='none' d='M0 0h24v24H0z')
                  path(d='M12 17c3.662 0 6.865 1.575 8.607 3.925l-1.842.871C17.347 20.116 14.847 19 12 19c-2.847 0-5.347 1.116-6.765 2.796l-1.841-.872C5.136 18.574 8.338 17 12 17zm0-15a5 5 0 0 1 5 5v3a5 5 0 0 1-4.783 4.995L12 15a5 5 0 0 1-5-5V7a5 5 0 0 1 4.783-4.995L12 2zm0 2a3 3 0 0 0-2.995 2.824L9 7v3a3 3 0 0 0 5.995.176L15 10V7a3 3 0 0 0-3-3z')
              .auth-btn(:style="authHover ? 'color: #F0232B !important;' : ''") {{ translate('auth.profile') }}
          hoverable-popup.gt-sm(:offset="[80, 10]" v-model:visible="showSmallCart")
            template(v-slot:button)
              q-item.row.items-center.q-mr-sm.q-px-sm.redHover(style="font-size: 1em; height: 36px;" no-caps dense clickable)
                .q-mr-sm.flex.flex-center
                  svg.cart-icon(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' :fill="showSmallCart ? '#e02838' : '#4e4f53'")
                    path(fill='none' d='M0 0h24v24H0z')
                    path(d='M7 8V6a5 5 0 1 1 10 0v2h3a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3zm0 2H5v10h14V10h-2v2h-2v-2H9v2H7v-2zm2-2h6V6a3 3 0 0 0-6 0v2z')
                .menuName(:class="showSmallCart ? 'redText' : ''") {{ translate('home.basket') }}
                .shopping-cart-count(v-if="shoppingCartCount > 0") {{shoppingCartCount}}
            template(v-slot:popup)
              small-cart(@clicked="showSmallCart = false")

    .full-width.greenGradient(style="height: 40px;").flex.justify-center
      .contentWidth.row.flex.items-center.full-height
        hoverable-popup(:offset="[0, 0]" v-model:visible="productPopupShown")
          template(v-slot:button)
            .link.flex.items-center(:class="productPopupShown ? 'linkHover' : ''") {{ translate('home.products') }}
          template(v-slot:popup)
            .productContainer
              .row.full-width
                .col-6
                  router-link.item(v-for="category in firstCategories" :key="category._id" @click="openCategory(category)" :to="'/termekek/'+category.url") {{ category.name }}
                .col-6
                  router-link.item(v-for="category in secondCategories" :key="category._id" @click="openCategory(category)" :to="'/termekek/'+category.url") {{ category.name }}
        hoverable-popup(:offset="[0, 0]" v-model:visible="productFamilyPopupShown")
          template(v-slot:button)
            .link.flex.items-center(:class="productFamilyPopupShown ? 'linkHover' : ''") {{ translate('home.productFamilies') }}
          template(v-slot:popup)
            .productFamilyContainer.row(style="width: 260px !important;")
              router-link.item(v-for="productFamily in productFamilies" :key="productFamily._id" @click="openProductFamily(productFamily)" :to="'/termekek/'+productFamily.url") {{ productFamily.name }}
        router-link.link(to="/blog" @click="$route.path === '/blog' ? closePopups() : openUrl('/blog')") {{ translate('home.blog') }}
        router-link.link(to="/szakertoink-valaszai" @click="$route.path === '/szakertoink-valaszai' ? closePopups() : openUrl('/szakertoink-valaszai')") {{ translate('home.expertAnswers') }}
        router-link(v-for="menu in extraMenus" :to="'/oldal/'+menu.slug" @click="$route.path === `/oldal/${menu.slug}` ? closePopups() : openUrl(`/oldal/${menu.slug}`)" :key="menu.menuName").link {{ menu.menuName }}
</template>

<style lang="sass">
.fixedElement
  background-color: #c0c0c0
  position: fixed
  top: 0
  width: 100%
  z-index: 100
.mobile-header
  display: flex
  flex-direction: row
  height: 55px
  align-items: center
  justify-content: space-evenly
  background-color: white
  box-shadow: 1px 2px 3px 0 rgba(24,25,27,0.09)
  -webkit-box-shadow: 1px 2px 3px 0 rgba(24,25,27,0.09)
  -o-box-shadow: 1px 2px 3px 0 rgba(24,25,27,0.09)
  -moz-box-shadow: 1px 2px 3px 0 rgba(24,25,27,0.09)
.auth-btn, .auth-icon
  transition: all .33s
.auth-btn
  font-size: 18px
.revealed
  background-color: rgba(255,255,255,0.94)
  transition: background-color 1s ease-in-out
.not-revealed
  background-color: rgba(255,255,255,0.01)
  transition: background-color 1s ease-in
.topHeaderText
  font-weight: 400
  font-size: 13px
  line-height: 1.25rem
  letter-spacing: .2px
  color: #626262
.linkHover
  &:hover
    background: #5B81D8 !important
    transition: background-color 0.5s ease
.link
  cursor: pointer
  font-weight: 400
  font-size: 1rem
  line-height: 1.5rem
  text-transform: none
  letter-spacing: .2px
  height: 100%
  padding: 0 15px 0 15px
  display: flex
  align-items: center
  justify-content: center
  color: white
  transition: background-color .3s,color .3s
  white-space: normal
  &:hover
    background: #5B81D8 !important
    transition: background-color 0.5s ease
.menuName
  color: #4D4F53
  font-size: 18px
  font-family: 'Work Sans', sans-serif
.loginBox
  width: 330px
  height: 208px
  display: flex
  border-radius: 10px
  justify-content: center
  align-items: center
  border: 1px solid #e5e6e9
  padding: 10px 0px 10px 0px
  background: white
  .title
    color: #4D4F53
    font-size: 20px
    font-weight: 600
    font-family: 'Work Sans', sans-serif
    margin: 5px 0 5px 0
    width: 100%
    text-align: center
  .btn
    width: 300px
    border-radius: 6px
    height: 52px
    background: #DFE0E3
    background: -moz-linear-gradient(90deg, rgba(16,108,235,1) 0%, rgba(241,34,42,1) 100%)
    background: -webkit-linear-gradient(90deg, rgba(16,108,235,1) 0%, rgba(241,34,42,1) 100%)
    background: linear-gradient(90deg, rgba(16,108,235,1) 0%, rgba(241,34,42,1) 100%)
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#106ceb",endColorstr="#f1222a",GradientType=1)
    display: flex
    justify-content: center
    align-items: center
    color: white
    text-transform: uppercase
    font-size: 15px
    font-weight: 600
    font-family: 'Work Sans', sans-serif
    margin: 10px 0 10px 0
    cursor: pointer
  .btn2
    width: 300px
    border-radius: 6px
    height: 52px
    background: #DFE0E3
    display: flex
    justify-content: center
    align-items: center
    color: #4D4F53
    text-transform: uppercase
    font-size: 15px
    font-weight: 600
    font-family: 'Work Sans', sans-serif
    margin: 10px 0 10px 0
    cursor: pointer
.auth-icon, .cart-icon, .menuName
  transition: all .33s
.shopping-cart-count
  margin-left: 6px
  background: #e02838
  border-radius: 100px
  font-size: 16px
  font-weight: 600
  width: 35px
  padding: 2px
  display: flex
  color: white
  line-height: 1.2
  justify-content: center
  align-items: center
.redText
  color: rgb(241,34,42) !important
.redHover
  &:hover
    color: rgb(241,34,42) !important
.productContainer
  border-bottom-left-radius: 10px
  border-bottom-right-radius: 10px
  width: 560px
  background: white
  border: 1px solid #e3e4e6
  padding: 25px 15px 25px 15px
  .item
    color: #4D4F53
    cursor: pointer
    width: 250px
    min-height: 40px
    border-radius: 5px
    font-size: 15px
    font-weight: 600
    padding: 8px 0px 8px 15px
    margin: 0px 7px 0 7px
    display: flex
    align-items: center
    &:hover
      color: #106CEC
      background: #DCE9FB
      transition: background-color 0.3s ease
.productFamilyContainer
  border-bottom-left-radius: 10px
  border-bottom-right-radius: 10px
  border: 1px solid #e3e4e6
  width: 280px
  background: white
  padding: 10px
  .item
    color: #4D4F53
    cursor: pointer
    width: 240px
    min-height: 40px
    border-radius: 5px
    font-size: 15px
    font-weight: 600
    padding: 8px 0px 8px 15px
    margin: 0px 7px 0 7px
    display: flex
    align-items: center
    &:hover
      color: #106CEC
      background: #DCE9FB
      transition: background-color 0.3s ease
.headerShadow
  box-shadow: 1px 2px 3px 0px rgba(24,25,27,0.09)
  -webkit-box-shadow: 1px 2px 3px 0px rgba(24,25,27,0.09)
  -moz-box-shadow: 1px 2px 3px 0px rgba(24,25,27,0.09)
</style>
